import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../lib/cn';

/**
 * Tag variants using CVA (Class Variance Authority)
 * Defines all visual variations of the Tag component
 */
const tagVariants = cva(
  // Base styles (always applied)
  [
    'inline-block',
    'border-2 border-linkode-text',
    'px-3 py-1',
    'font-mono text-sm font-bold',
    'shadow-linkode-hover',
    'transition-colors duration-300',
  ],
  {
    variants: {
      variant: {
        yellow: 'bg-linkode-yellow',
        teal: 'bg-linkode-teal',
        primary: 'bg-linkode-primary',
      },
    },
    defaultVariants: {
      variant: 'yellow',
    },
  }
);

/** Exported type for Tag variants */
export type TagVariants = VariantProps<typeof tagVariants>;

export interface TagProps extends React.HTMLAttributes<HTMLSpanElement>, TagVariants {
  /** Tag content */
  children: React.ReactNode;
}

/** Hero tag component with MotherDuck-style shadow */
export const Tag: React.FC<TagProps> = ({ variant, className, children, ...props }) => {
  return (
    <span className={cn(tagVariants({ variant }), className)} {...props}>
      {children}
    </span>
  );
};

// Export tagVariants for external use (e.g., testing)
export { tagVariants };
